const elementsToShow = document.querySelectorAll( '.animate' );

let scroll = window.requestAnimationFrame || function( callback ){ window.setTimeout( callback, 1000/60 ); };

const init = function() {
	loop();
};


/**
 *
 *
 *
 */
const loop = function() {
	elementsToShow.forEach( ( element ) => {
		const baseClass = 'animated';
		if ( isElementInViewport( element ) ) {
			if ( element.classList.contains( baseClass ) ) {
				return;
			}
			element.classList.add( baseClass );
		}
	});
	scroll( loop );
};


/**
 *
 *
 *
 */
const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;